import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Header, Icon, MessageProps, Transition } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import Input from 'components/final-form/Input';
import LanguageDropdown from 'routes/login/segments/LanguageDropdown';

interface Props extends MessageSourceProps {
  success: boolean,
  error: boolean,
  errorMessage: string,
  submitting: boolean,
  visible: boolean
  validatorImpl: () => void,
  goToLogin: () => void,
  renderMessage: (header: string, text: string, messageProps: MessageProps) => React.ReactNode
}

class ResetPasswordSegment extends Component<Props> {


  renderHeaderContent = (): React.ReactNode => {

    const {getMessage} = this.props;

    return (
        <Header as='h2' icon textAlign='center'>
          <Icon name='lock' circular/>
          <Header.Content>{getMessage('resetPassword.enterPassword')}</Header.Content>
        </Header>
    )
  };

  renderFormContent = (): React.ReactNode => {

    const {getMessage, submitting, visible, validatorImpl} = this.props;

    const validator = visible ? validatorImpl : undefined;

    return (
        <React.Fragment>
          <Grid.Row verticalAlign='middle'>
            <Grid.Column>
              <Field
                  name='password'
                  component={Input}
                  type='password'
                  placeholder={getMessage('login.user.password.hint')}
                  icon='lock'
                  validate={validator}
              />
              <Field
                  name='repeatPassword'
                  component={Input}
                  type='password'
                  placeholder={getMessage('resetPassword.repeatPassword')}
                  icon='lock'
                  validate={validator}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Button type='submit' primary fluid disabled={submitting}>
              {getMessage('resetPassword.confirm')}
            </Button>
          </Grid.Row>
        </React.Fragment>
    )
  };

  render(): React.ReactNode {

    const {success, error, submitting, visible, errorMessage, goToLogin, renderMessage, getMessage} = this.props;

    const successHeader = getMessage('resetPassword.success');
    const successText = getMessage('resetPassword.passwordChangeSuccess');

    const errorHeader = getMessage('resetPassword.email');

    return (
        <Transition animation={"scale"} duration={400} visible={visible}>
          <div>
            {!success && this.renderHeaderContent()}
            <Grid verticalAlign="middle">
              {!success && this.renderFormContent()}
              <Button type='button' basic fluid onClick={goToLogin} disabled={submitting} loading={submitting}>
                {getMessage('resetPassword.goToLogin')}
              </Button>
              <Grid.Row>
                <Grid.Column>
                  {success && renderMessage(successHeader, successText, {positive: true})}
                  {error && renderMessage(errorHeader, errorMessage, {negative: true})}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <LanguageDropdown/>
          </div>
        </Transition>
    );
  }
}

export default withMessages(ResetPasswordSegment);
